module.exports = __webpack_public_path__ + "static/homepic-6c3b7b52d29671724aaa96060419848b.png";